import Vue from 'vue';
import Router from 'vue-router';
import DefaultLayout from '@shared/layouts/default';
import AuthLayoutWrapper from '@shared/layouts/auth';
import ErrorPage from '@shared/pages/errors/404';
import { is_auth } from './middleware/auth';
import { core, auth } from '@core/routes';
import { autoinformer } from '@autoinformer/routes';
import { autocaller_v2 } from '@autocaller_v2/routes';
import { call_tracking } from '@call-tracking/routes';
import { db } from '@db/routes';
import { mailer } from '@mailer/routes';
import { phone_number } from '@phone-number/routes';
import { referral } from '@referral/routes';
import { verification } from '@verification/routes';
import { voice } from '@voice/routes';
import { predictive_connect } from '@predictive_connect/routes';
import { notify } from '@notify/routes';
import { pbx } from '@pbx/routes';
import { worksheet_crud } from '@pbx/routes/worksheet-crud';
import { autoinformer_worksheet_route } from '@autoinformer/routes/autoinformer_worksheet_route';
import { integration } from '@/modules/integration/route';
import { integrations } from '@/modules/integrations/routes';
import { hlr } from '@/modules/hlr/routes';

Vue.use(Router);
/**
 * TODO :: Некоторые разделы могут быть запрещены пользователю
 * Нужно подумать:
 *  - Как получать и где хранить инфу о том, доступен ли раздел
 *  - Как обновлять эту инфу, при изменениях на беке
 *  - Для раздела pbx всегда нужен тариф + ограничения на создание сущностей (есть в тарифе)
 *    их тоже нужно держать в актуальном состоянии
 */
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  },
  routes: [
    {
      path: '/',
      beforeEnter: is_auth,
      component: AuthLayoutWrapper,
      children: [
        {
          path: '',
          component: DefaultLayout,
          meta: {
            bodyClass: 'layout'
          },
          children: [
            ...core,
            ...autoinformer,
            ...autocaller_v2,
            ...predictive_connect,
            ...call_tracking,
            ...db,
            ...mailer,
            ...phone_number,
            ...referral,
            ...verification,
            ...voice,
            ...notify,
            ...pbx,
            ...integration,
            ...integrations,
            ...hlr
          ]
        },

        /**
         * AuthLayoutWrapper - чтобы удостоверится что пользователь авторизован.
         * DefaultLayout - Стандартный Layout [header, sidebar, content, footer]
         * Роуты что ниже - имеею свой Layout
         */

        worksheet_crud,
        autoinformer_worksheet_route
      ]
    },
    auth,
    {
      path: '*',
      component: ErrorPage
    }
  ]
});
